/* eslint-disable */
import {loadScript} from '../../helpers/helpers';
import {mainState} from '../../AppMainState';
import * as MusculaLog from '@muscula.com/muscula-webapp-js-logger';

export function setupPaddle() {
    return loadScript('https://cdn.paddle.com/paddle/paddle.js', 'paddle')
        .then(() => {
            Paddle.Setup({vendor: 123409}); //TODO: Przenieść do konfigu
        })
        .catch(err => {
            MusculaLog.Error('Error when loading paddle', err);
            console.error('Error when loading paddle', err);
        })
}

//openCheckout(637094)
export function openCheckout(productId) {
    setupPaddle().then(() => {
        Paddle.Checkout.open({
            product: productId,
            email: mainState.currentUser.email,
            passthrough: mainState.currentUser.userId,
        });
    })
}
